import { createFileRoute, Link } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import { useNavigationManager } from "~/managers/use-navigation-manager";

export const Route = createFileRoute("/_main/reports/_layout/")({
  component: Reports,
});

function Reports() {
  const { reportsNavItems } = useNavigationManager();
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 grid-cols-1 gap-4">
      {reportsNavItems.map((navItem) => (
        <Link to={navItem.href} key={navItem.name}>
          <Button variant="outline" className="h-24 text-xl w-full">
            {navItem.name}
          </Button>
        </Link>
      ))}
    </div>
  );
}
